import axios from 'axios';

import { getApiBaseUrl } from '../config/ApiConfig';
import { getMidwayJwtToken } from '../auth/MidwayJwtToken';

// Generic recent-runs store shared by all views, backed by DynamoDB via the API.

// Single source of truth lives in views/types.ts (shared with the view registry).
import type { RecentViewType } from '../views/types';
export type { RecentViewType };

export interface RecentRunItem {
  view_type: RecentViewType;
  submitted_at: string;
  run_id: string;
  label: string;
  params: Record<string, unknown>;
  handle: Record<string, unknown>;
  status: string;
}

async function authHeader(): Promise<Record<string, string>> {
  const token = await getMidwayJwtToken();
  return { Authorization: `Bearer ${token}` };
}

export async function saveRecentRun(
  input: {
    view_type: RecentViewType;
    label: string;
    params: Record<string, unknown>;
    handle: Record<string, unknown>;
    status?: string;
  },
  signal?: AbortSignal
): Promise<RecentRunItem> {
  const res = await axios.post<RecentRunItem>(
    `${getApiBaseUrl()}/runs`,
    input,
    { headers: await authHeader(), signal }
  );
  return res.data;
}

export async function getRecentRuns(
  viewType: RecentViewType,
  limit = 20,
  signal?: AbortSignal
): Promise<RecentRunItem[]> {
  const res = await axios.get<RecentRunItem[]>(
    `${getApiBaseUrl()}/runs/recent`,
    { params: { viewType, limit }, headers: await authHeader(), signal }
  );
  return res.data;
}

export async function clearRecentRuns(
  viewType: RecentViewType,
  signal?: AbortSignal
): Promise<void> {
  await axios.delete(`${getApiBaseUrl()}/runs`, {
    params: { viewType },
    headers: await authHeader(),
    signal,
  });
}
